import AlertMsg from "./AlertMsg";

export default function displayAlertMsg(message, variant = 'danger') {
    return message?.length > 0 ?
        <AlertMsg message={message} variant={variant}/> :
        <AlertMsg/>
}